import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectEmailVerifyDomain = state => state.emailVerifyContainerReducer || initialState;

export const selectProfileModalDomain = state => state.profileModalReducer || initialState;
export const selectRouterDomain = state => state.router || {};

export const getUserInfoSelector = () => createSelector(selectProfileModalDomain, ({ userInfo }) => userInfo);

export const getEmailVerifyInfoSelector = () =>
	createSelector(selectEmailVerifyDomain, ({ emailVerifyInfo }) => emailVerifyInfo);

export const getIsFormSendingSelector = () =>
	createSelector(selectEmailVerifyDomain, ({ isFormSending }) => isFormSending);

export const getIsFormLoadingSelector = () =>
	createSelector(selectEmailVerifyDomain, ({ isFormLoading }) => isFormLoading);
